<template>
  <v-chip v-if="item.badge" 
          :color="item.badge.color" 
          :outlined="item.badge.outlined"
          :dark="isDark"
          :x-small="small">
    <v-icon left 
            v-if="item.badge.icon">
      {{ item.badge.icon }}
    </v-icon>
    {{ item.badge.name }}
  </v-chip>
</template>

<style lang="scss">

</style>

<script>
export default {

  name: 'Badge',

  mixins: [],

  components:
  {

  },

  data: () => ({

  }),

  props:
  {
    item: {
      required: true
    },
    small: {
      type: Boolean,
      default: false
    }
  },

  computed:
  {
    isDark()
    {
      const colors = [ 'black', 'grey' ],
            color = this.item.badge.color
      
      return (colors.indexOf(color) >= 0)
    }
  },

  methods:
  {
    
  },

  load() { }
}
</script>